/* global FormData, fetch */
import { FETCH_ACCOUNT_DETAILS_FULFILLED } from '../actions';
import {
  updateBrandFavouriteActionCreator,
  REQUEST_BRAND_UPDATE_FAVOURITE_STATUS,
  getFavouritedBrandsCreator,
} from '../actions/favouritedBrands';
import { getEveApiAccessToken, getEveApiUrl, isGuestAccount } from '../selectors';
import { getSponsoredBrandProductsSlices } from '../selectors/sponsoredBrands';
import { handleBadResponse } from './fetchJson';

const favouriteBrand = async (url, token, brandId) => {
  const formData = new FormData();
  formData.append('id', brandId);
  formData.append('status', true);

  const response = await fetch(`${url}/customer/brands`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (!response.ok) {
    await handleBadResponse(response, `Failed to update brand: ${response.statusText}`);
  }

  return response.json();
};

const unfavouriteBrand = async (url, token, brandId) => {
  const response = await fetch(`${url}/customer/brands/${brandId}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      status: 'false',
    }),
  });

  if (!response.ok) {
    await handleBadResponse(response, `Failed to update brand: ${response.statusText}`);
  }

  return response.json();
};

const dispatchFavouriteBrand = (store, action) => {
  const state = store.getState();

  if (isGuestAccount(state)) {
    return;
  }

  const apiUrl = getEveApiUrl(state);
  const token = getEveApiAccessToken(state);
  const { brandId, status } = action.payload;
  const promise = status ? favouriteBrand : unfavouriteBrand;

  store.dispatch(updateBrandFavouriteActionCreator(
    brandId,
    status,
    promise(apiUrl, token, brandId),
  ));
};

const getFavouritedBrandIds = async (url, token) => {
  const response = await fetch(`${url}/customer/brands`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    await handleBadResponse(response, `Failed to get favourited brands: ${response.statusText}`);
  }

  const data = await response.json();
  // eslint-disable-next-line no-underscore-dangle
  return data?._embedded?.brand?.map(item => item.id) || [];
};

const dispatchGetFavouritedBrands = store => {
  const state = store.getState();
  const apiUrl = getEveApiUrl(state);
  const token = getEveApiAccessToken(state);

  const hasSponsoredBrandProducts = getSponsoredBrandProductsSlices(state).length > 0;
  const shouldFetchFavouritedBrands = hasSponsoredBrandProducts && !!token;
  if (!shouldFetchFavouritedBrands) {
    return;
  }

  store.dispatch(getFavouritedBrandsCreator(getFavouritedBrandIds(apiUrl, token)));
};

export default store => next => action => {
  const ret = next(action);
  switch (action.type) {
    case FETCH_ACCOUNT_DETAILS_FULFILLED: // Token is available after fetching account detail
      dispatchGetFavouritedBrands(store);
      break;
    case REQUEST_BRAND_UPDATE_FAVOURITE_STATUS:
      dispatchFavouriteBrand(store, action);
      break;
    // no default
  }
  return ret;
};
